import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

interface IPoolHotelData {
  "id": number,
  "code": string,
  "area_id": string,
  "code_area": string,
  "pool_id": string,
  "pool_id_2": string,
  "pool_name": string,
  "is_active": boolean,
  "create_at": string,
  "create_by": string,
  "update_at": string,
  "update_by": string
}
export interface IGetPoolsAndHotelsResponse {
  "lstMtPoolModel": IPoolHotelData[]
}

const url = "/v1/smplmtpoolhotel";

export const getPoolsAndHotels = async (codeType: string): Promise<IGetPoolsAndHotelsResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/Code/${codeType}/isactive/true`,
    method: "GET",
  });

  return data;
};
